// extracted by mini-css-extract-plugin
export default {"button":"_1hULE","wrapper":"_3lSLD","label":"_3bJQN"};